import React, { useMemo } from 'react';
import theme from './ResidentialUnitDetailsQuickNav.module.scss';
import { useAsyncState, useParamReplace } from '@/utils/hooks';
import { getResidentialUnitsByProjectIdWithExtraData } from '@/services/residential-units';
import { CustomLink } from '@/components/navigation';
import { orderBy } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowLeft, faLongArrowRight } from '@fortawesome/pro-light-svg-icons';

interface ResidentialUnitDetailsQuickNavProps {
    currentResidentialUnitId: number;
    projectId: number;
}

const ResidentialUnitDetailsQuickNav: React.FC<ResidentialUnitDetailsQuickNavProps> = ({
    currentResidentialUnitId,
    projectId,
}) => {
    const [projectUnits] = useAsyncState(() => getResidentialUnitsByProjectIdWithExtraData(projectId), [projectId], null);

    const replaceParam = useParamReplace<{ residentialUnitId: number }>();
    const sortedUnits = useMemo(() => (projectUnits ? orderBy(projectUnits, ['residentialUnitGroupName', 'name']) : null), [
        projectUnits,
    ]);

    if (!sortedUnits) {
        return null;
    }

    const currentUnitIndex = sortedUnits.findIndex((x) => x.id === currentResidentialUnitId);

    if (currentUnitIndex === -1) {
        return null;
    }

    const previousIndex = currentUnitIndex === 0 ? sortedUnits.length - 1 : currentUnitIndex - 1;
    const nextIndex = currentUnitIndex + 1 >= sortedUnits.length ? 0 : currentUnitIndex + 1;

    const previousUnit = sortedUnits[previousIndex];
    const nextUnit = sortedUnits[nextIndex];

    return (
        <div className={theme.container}>
            <CustomLink to={replaceParam({ residentialUnitId: previousUnit.id })}>
                <FontAwesomeIcon icon={faLongArrowLeft} />
                {previousUnit.name}
            </CustomLink>
            <CustomLink to={replaceParam({ residentialUnitId: nextUnit.id })}>
                {nextUnit.name}
                <FontAwesomeIcon icon={faLongArrowRight} />
            </CustomLink>
        </div>
    );
};

export default ResidentialUnitDetailsQuickNav;
